// Navigation
(() => {
    const desktopBreakpoint = 992;

    const closeDropdown = (chevron) => {
        const dropdown = chevron.closest('.nav__item')?.querySelector('.nav__dropdown');
        if (!dropdown) return;

        const navItem = chevron.closest('.nav__item');
        chevron.classList.remove('nav__chevron--active');
        chevron.setAttribute('aria-expanded', 'false');
        dropdown.classList.remove('nav__dropdown--active');
        dropdown.setAttribute('aria-hidden', 'true');
        navItem?.classList.remove('active');
        // Remove links from tab order when hidden
        dropdown.querySelectorAll('a').forEach((el) => el.setAttribute('tabindex', '-1'));
    };

    const positionDropdown = (dropdown) => {
        // Only apply on desktop
        if (window.innerWidth <= desktopBreakpoint) return;

        // Remove right positioning initially
        dropdown.classList.remove('nav__dropdown--right');

        // Get dropdown position
        const rect = dropdown.getBoundingClientRect();
        const viewportWidth = window.innerWidth;

        // If dropdown extends beyond viewport, align it to the right instead
        if (rect.right > viewportWidth) {
            dropdown.classList.add('nav__dropdown--right');
        }
    };

    const positionAllDropdowns = () => {
        document.querySelectorAll('.nav__dropdown').forEach(positionDropdown);
    };

    // Debounce helper for resize
    let resizeTimeout;
    const debouncedPositionDropdowns = () => {
        clearTimeout(resizeTimeout);
        resizeTimeout = setTimeout(positionAllDropdowns, 150);
    };

    const closeMobile = () => {
        const toggle = document.querySelector('.nav__toggle');
        const nav = document.querySelector('.nav');
        if (toggle?.getAttribute('aria-expanded') === 'true') {
            toggle.classList.remove('nav__toggle--active');
            nav.classList.remove('nav--active');
            document.body.classList.remove('overflow-hidden', 'nav--open');
            toggle.setAttribute('aria-expanded', 'false');
        }
    };

    // Mobile menu
    document.querySelector('.nav__toggle')?.addEventListener('click', () => {
        const toggle = document.querySelector('.nav__toggle');
        const nav = document.querySelector('.nav');
        const isOpen = toggle.getAttribute('aria-expanded') === 'true';

        if (!isOpen) {
            window.search?.close();
            document.querySelectorAll('.nav__chevron').forEach(closeDropdown);
        }

        toggle.classList.toggle('nav__toggle--active');
        nav.classList.toggle('nav--active');
        document.body.classList.toggle('overflow-hidden');
        document.body.classList.toggle('nav--open');
        toggle.setAttribute('aria-expanded', !isOpen);
    });

    // Dropdowns
    document.querySelectorAll('.nav__chevron').forEach((chevron) => {
        chevron.addEventListener('click', (e) => {
            e.preventDefault();
            e.stopPropagation(); // Prevent outside click from triggering
            const isOpen = chevron.getAttribute('aria-expanded') === 'true';

            if (!isOpen) {
                window.search?.close();
                // Only close mobile nav on desktop, not on mobile
                if (window.innerWidth > desktopBreakpoint) {
                    closeMobile();
                }
                document
                    .querySelectorAll('.nav__chevron')
                    .forEach((c) => c !== chevron && closeDropdown(c));
            }

            if (isOpen) {
                closeDropdown(chevron);
            } else {
                const dropdown = chevron.closest('.nav__item')?.querySelector('.nav__dropdown');
                const navItem = chevron.closest('.nav__item');
                if (dropdown) {
                    chevron.classList.add('nav__chevron--active');
                    chevron.setAttribute('aria-expanded', 'true');
                    dropdown.classList.add('nav__dropdown--active');
                    dropdown.setAttribute('aria-hidden', 'false');
                    navItem?.classList.add('active');
                    // Add links back to tab order when shown
                    dropdown.querySelectorAll('a').forEach((el) => el.removeAttribute('tabindex'));
                }
            }
        });

        chevron.addEventListener('keydown', (e) => {
            if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                e.stopPropagation();
                chevron.click();
            } else if (e.key === 'Escape') {
                closeDropdown(chevron);
            }
        });
    });

    // Global keyboard navigation
    document.addEventListener('keydown', (e) => {
        const dropdown = document.querySelector('.nav__dropdown--active');
        if (!dropdown) return;

        if (e.key === 'Escape') {
            e.preventDefault();
            const chevron = dropdown.closest('.nav__item').querySelector('.nav__chevron');
            closeDropdown(chevron);
            chevron?.focus();
        }
    });

    // Outside click
    document.addEventListener('click', (e) => {
        // Close dropdowns if clicking outside nav items
        if (!e.target.closest('.nav__item')) {
            document.querySelectorAll('.nav__chevron').forEach(closeDropdown);
        }
    });

    // Position all dropdowns on load and resize
    positionAllDropdowns();
    window.addEventListener('resize', debouncedPositionDropdowns);

    // Global access
    window.nav = { closeDropdown, closeMobile };
})();
